import React from 'react';
import { FaCircleChevronRight } from 'react-icons/fa6';

import { Spin } from 'antd';
import MergeClassNames from 'utils/MergeClassNames';

// Shared by the sidebar farm tree and the copy tool trees (OP-2519).

export const TreeLoadingState = ({ message }: { message: string }) => (
  <div className="flex flex-col items-center py-6 text-gray-muted">
    <Spin />
    <span className="mt-2 text-sm">{message}</span>
  </div>
);

export const TreeErrorState = ({ message }: { message: string }) => (
  <div className="px-4 py-3 text-sm text-danger">{message}</div>
);

// Takes the task grid's icon, size and grey so the two trees share one visual
// vocabulary, but keeps the sidebar's own rotation: down when collapsed, up
// when expanded. The grid points right-then-down because its rows unfold
// beneath a single header; a vertical tree reads better with the arrow pointing
// the way the branch will move.
export const SwitcherIcon = ({ expanded }: { expanded: boolean }) => (
  <FaCircleChevronRight
    size={16}
    className={MergeClassNames(
      'text-secondary-dark transition-transform duration-150',
      expanded ? '-rotate-90' : 'rotate-90'
    )}
  />
);
